(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1507],{

/***/ 40909:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/celebrity/[slug]",
      function () {
        return __webpack_require__(88373);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20010);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99731);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17651);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3245);







var CategorySectionFull = function(param) {
    var headline = param.headline, plays = param.plays, theatre = param.theatre, index = param.index;
    var ref = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_3__/* .Namespace.Common */ .l.Common), lang = ref.lang, t = ref.t;
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-section category-section-full ".concat(!index || index === 0 ? "first" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "play-list-wrapper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: headline
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "play-list",
                    children: plays === null || plays === void 0 ? void 0 : plays.map(function(play, i) {
                        var ref;
                        // onClick={() => playsGEvent(item.permalink)}
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                href: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Permalink.play */ .xm.play(play, lang),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    tabIndex: -1,
                                    children: [
                                        play.state === _typings_api__WEBPACK_IMPORTED_MODULE_5__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "coming-soon",
                                            children: t("coming_soon")
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            placeholderClass: "image-wrapper-for-playlist",
                                            src: play.poster_url,
                                            alt: play.title,
                                            width: 256,
                                            height: 144,
                                            quality: 90
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .truncateTitle */ .ew)(play.title)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: (ref1 = play === null || play === void 0 ? void 0 : (ref = play.theatre) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : theatre
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySectionFull);


/***/ }),

/***/ 88373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./components/CategorySections/CategorySectionFull.tsx
var CategorySectionFull = __webpack_require__(60604);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./node_modules/sanitize-html-react/index.js
var sanitize_html_react = __webpack_require__(93826);
var sanitize_html_react_default = /*#__PURE__*/__webpack_require__.n(sanitize_html_react);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(49573);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(57919);
;// CONCATENATED MODULE: ./models/Celebrity.ts




var Celebrity = /*#__PURE__*/ function() {
    "use strict";
    function Celebrity() {
        (0,_class_call_check/* default */.Z)(this, Celebrity);
    }
    var _proto = Celebrity.prototype;
    _proto.playsForRole = function playsForRole(role) {
        return this.contributions.map(function(cont) {
            return cont.roles.indexOf(role) > -1 ? cont.play : null;
        }).filter(function(x) {
            return !!x;
        });
    };
    _proto.localisedSlug = function localisedSlug(locale) {
        var ref, ref1, ref2;
        var ref3, ref4;
        return (0,helpers/* slugifyString */.V3)((ref4 = (ref3 = (ref1 = (ref = this.names) === null || ref === void 0 ? void 0 : ref.find(function(n) {
            return n.language === locale;
        })) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref3 !== void 0 ? ref3 : (ref2 = this.names) === null || ref2 === void 0 ? void 0 : ref2.find(function(n) {
            return n.language === i18n.defaultLocale;
        }).value) !== null && ref4 !== void 0 ? ref4 : this.name);
    };
    Celebrity.fromJSON = function fromJSON(json) {
        return Object.assign(new Celebrity(), json);
    };
    (0,_create_class/* default */.Z)(Celebrity, [
        {
            key: "shortName",
            get: function get() {
                return (0,helpers/* twoLetterShortName */.mZ)(this.name);
            }
        },
        {
            key: "flattenedContributions",
            get: function get() {
                return (0,helpers/* unifyArray */.mR)(this.contributions.map(function(contribution) {
                    return contribution.roles;
                }).flat());
            }
        }
    ]);
    return Celebrity;
}();
/* harmony default export */ var models_Celebrity = (Celebrity);

// EXTERNAL MODULE: ./components/DramoxImage/index.tsx
var DramoxImage = __webpack_require__(20010);
// EXTERNAL MODULE: ./config/routeTable.ts
var routeTable = __webpack_require__(82278);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
;// CONCATENATED MODULE: ./pages/celebrity/[slug]/index.tsx















var CelebrityDetail = function(param) {
    var celebrityJSON = param.celebrityJSON, countryCode = param.countryCode;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    var locale = (0,langContext/* useLang */.J)().locale;
    var celebrity = models_Celebrity.fromJSON(celebrityJSON);
    var structuredSEOData = (0,react.useMemo)(function() {
        return {
            "@context": "https://schema.org/",
            "@type": "Person",
            name: celebrity.name,
            image: celebrity.poster_url
        };
    }, [
        celebrity
    ]);
    var ref1 = (0,react.useMemo)(function() {
        var ref;
        if (celebrity.about) {
            return [
                celebrity.about,
                true
            ];
        }
        var plays = (ref = celebrity.contributions) === null || ref === void 0 ? void 0 : ref.map(function(c) {
            var ref;
            return (ref = c.play) === null || ref === void 0 ? void 0 : ref.title;
        }).filter(function(play) {
            return Boolean(play);
        }).slice(0, 2);
        if (plays.length > 0) {
            var ref1, ref2;
            return [
                t("seo:celebrity_default_about", {
                    name: celebrity.name,
                    plays: plays.join(", "),
                    theatre: (ref1 = celebrity.contributions[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.play) === null || ref2 === void 0 ? void 0 : ref2.theatre.name
                }),
                false, 
            ];
        } else {
            return [
                t("seo:playlist_currently_watching_description"),
                false
            ];
        }
    }, [
        celebrity,
        t
    ]), seoDescription = ref1[0], truncateSeoDescription = ref1[1];
    var celebrityAbout = (0,react.useMemo)(function() {
        if (!celebrity.about) {
            return "";
        }
        var ret = sanitize_html_react_default()(celebrity.about);
        if (celebrity.kinobox && Boolean(ret)) {
            var ref;
            var name = (ref = celebrity === null || celebrity === void 0 ? void 0 : celebrity.names.find(function(n) {
                return n.language === locale;
            })) === null || ref === void 0 ? void 0 : ref.value;
            if (name) {
                var link = '<a href="'.concat((0,helpers/* kinoboxLink */.vB)("person", celebrity.kinobox, name), '" target="_blank" rel="external">').concat(name, "</a>");
                ret = ret.replace(new RegExp(name, "g"), link);
            }
        }
        return ret;
    }, [
        celebrity.about,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    (0,jsx/* basicSEO */.F)(t("seo:celebrity_title", {
                        name: celebrity.name
                    }), seoDescription, celebrity.poster_url, null, truncateSeoDescription),
                    ";",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredSEOData)
                        }
                    }),
                    i18n.locales.map(function(langLocale) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            href: "".concat((0,routeTable/* baseUrl */.F)(langLocale)).concat(helpers/* Permalink.celebrity */.xm.celebrity(celebrity, langLocale)),
                            hrefLang: langLocale
                        }, langLocale);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: "".concat((0,routeTable/* baseUrl */.F)("en")).concat(helpers/* Permalink.celebrity */.xm.celebrity(celebrity, "en")),
                        hrefLang: "x-default"
                    }, "lang-default")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "author-detail",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "info-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-placeholder",
                                children: (celebrity === null || celebrity === void 0 ? void 0 : celebrity.poster_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DramoxImage/* default */.Z, {
                                    src: celebrity === null || celebrity === void 0 ? void 0 : celebrity.poster_url,
                                    alt: celebrity.name,
                                    width: 170,
                                    height: 170,
                                    quality: 90
                                }) : celebrity.shortName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: celebrity === null || celebrity === void 0 ? void 0 : celebrity.name
                                    }),
                                    Boolean(celebrityAbout) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "about",
                                        dangerouslySetInnerHTML: {
                                            __html: celebrityAbout
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    (ref = celebrity.flattenedContributions) === null || ref === void 0 ? void 0 : ref.map(function(role, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySectionFull/* default */.Z, {
                            headline: role,
                            index: i,
                            plays: celebrity.playsForRole(role)
                        }, i);
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = ((0,context/* withForcePlanToLoggedInUnsubs */.DE)(CelebrityDetail));


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3826,9774,2888,179], function() { return __webpack_exec__(40909); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);